import { Component, OnDestroy } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as showdown from 'showdown';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-generic-page',
  templateUrl: './generic-page.component.html',
  styleUrls: ['./generic-page.component.scss'],
})
export class GenericPageComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  converter;
  text;
  html;
  lang: string;

  page: string = '';
  pageTitle: string = '';

  constructor(
    private http: Http,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private route: ActivatedRoute,
  ) {
    this.lang = translate.currentLang;

    this.page = this.route.snapshot.data['page'];
    this.pageTitle = this.route.snapshot.data['title'];

    this.loadMarkdownFile();

    translate.onLangChange.takeUntil(this.ngUnsubscribe).subscribe(() => {
      this.lang = translate.currentLang;
      this.loadMarkdownFile();
    });
  }

  private loadMarkdownFile() {
    this.http
      .get('assets/i18n/' + this.page + '/' + this.lang + '.md')
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        (text) => {
          this.text = text['_body'];

          this.convertMarkdown();
        },
        () => {
          this.http
            .get('assets/i18n/' + this.page + '/de.md')
            .takeUntil(this.ngUnsubscribe)
            .subscribe(
              (text) => {
                this.text = text['_body'];

                this.convertMarkdown();
              },
              () => { },
            );
        },
      );
  }

  private convertMarkdown() {
    this.converter = new showdown.Converter({ tables: true, disableForced4SpacesIndentedSublists: true });
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.converter.makeHtml(this.text));
  }


  /**
  * On destroy cancel active subscriptions
  */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/generic-page/generic-page.component.ts